import React, { useState } from 'react';
import Button from '../Button/Button';
import Input from '../Input/Input';
import ServiceLocator from '../../../services/ServiceLocator';
import { ShowErrorMessage, HandleSuccess } from '../../../stores/page/actions';
import { useAppDispatch } from '../../../helpers/UseAppDispatch';
import { ContactFormRequest } from '../../../api/dtos/contactForm/ContactFormRequest';
import SuccessErrorMessage from '../../../PrivateSide/components/SuccesErrorMessage/SuccessErrorMessage';

const ContactForm: React.FC = () => {
    const dispatch = useAppDispatch();
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
        acceptTerms: false,
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, type, value } = e.target;

        if (type === 'checkbox') {
            const checked = (e.target as HTMLInputElement).checked;
            setFormData({
                ...formData,
                [name]: checked,
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData.name || !formData.email || !formData.message || !formData.acceptTerms) {
            setErrorMessage('Please fill in all fields.');
            return
        }
        const contactFormData: ContactFormRequest = {
            name: formData.name,
            email: formData.email,
            message: formData.message,
        };

        const response = await ServiceLocator.ContactFormService.SendContactForm(contactFormData);

        if (response.is_success) {
            setFormData({
                name: '',
                email: '',
                message: '',
                acceptTerms: false,
            });

            dispatch(HandleSuccess('Your message has been sent successfully!'));
        } else {
            dispatch(ShowErrorMessage(response.error_message ?? 'An error occurred while sending your message'));
        }
    };

    return (
        <form className='contact_form' id='contact_form' onSubmit={handleSubmit}>
            <h2>CONTACT US</h2>
            <br />
            <p>Fill out the form, our team is happy to answer your questions</p>
            <SuccessErrorMessage errorMessage={errorMessage} onClear={() => { setErrorMessage(''); }} sx={{ marginTop: '1.5rem' }} />
            <div className='contact_form_inputs'>
                <Input label='Name' type='text' name='name' value={formData.name} onChange={handleChange} />
                <Input label='Email' type='email' name='email' value={formData.email} onChange={handleChange} />
                <Input label='Message' type='textarea' name='message' placeholder='Type your message here' value={formData.message} onChange={handleChange} />
                <div className='contact_form_terms'>
                    <Input label='I accept the terms' type='checkbox' name='acceptTerms' value={formData.acceptTerms} onChange={handleChange} />
                </div>
            </div>
            <Button text='Send' type='submit' />
        </form>
    );
}

export default ContactForm;
